<template>
  <div>
    <!-- <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card> -->
    <!-- <el-card class="box-card">

    </el-card> -->
    <el-card>
      <div style="font-size: 16px; margin-bottom: 20px">
        {{ goodsItemIdData.name }}
      </div>
      <el-row :span="24">
        <el-col :span="24">
          <div>
            <el-button type="primary" @click="addGoodsVideo" icon="el-icon-plus">添加排班</el-button>
          </div>
        </el-col>
      </el-row>
      <div style="width: 100%" class="draggable-tableaaa">
        <div style class="draggable-table">
          <div class="answer bor" style="width: 20%">所属课程</div>
          <div class="answer bor" style="width: 40%">名称</div>
          <div class="answer bor" style="width: 20%">类型</div>
          <div class="delete bor" style="width: 20%">操作</div>
        </div>
        <draggable v-if="page.rows.length" v-model="page.rows" @update="datadragEnd" :options="{ animation: 500 }">
          <!-- <transition-group> -->
          <div v-for="(element, index) in page.rows" :key="index" class="drag-item">
            <div class="draggable-table">
              <el-tooltip :open-delay="500" class="item" effect="dark" :content="element.campusName">
                <div style="width: 20%" class="answer">
                  {{ element.campusName || "null" }}
                </div>
              </el-tooltip>
              <el-tooltip :open-delay="500" class="item" effect="dark" :content="element.subjectName">
                <div style="width: 40%" class="answer">
                  {{ element.subjectName || "null" }}
                </div>
              </el-tooltip>
              <div style="width: 20%" class="answer">
                <span>{{ element.type || "null" }}</span>
                <div v-if="element.powerList" style="display: inline">
                  <span class="line"></span>
                  <el-popover trigger="click" v-model="element.isPrpover">
                    <el-checkbox-group v-model="checkList">
                      <el-checkbox v-for="(item, index) in powerList" :key="index" :label="item.power">{{ item.name }}</el-checkbox>
                    </el-checkbox-group>
                    <el-button size="mini" type="primary" class="type-btn" @click="sunmitType(element)">提交</el-button>
                    <span slot="reference" @click="rangeCli(element)">范围<i class="el-icon-arrow-down el-icon--right"></i></span>
                  </el-popover>
                </div>
              </div>
              <!-- </el-tooltip> -->

              <!-- <el-tooltip :open-delay="500" class="item" effect="dark" :content="String(index+1)">
                <div
                  style="width:13.3%"
                  class="answer mainColor"
                  @click="opConmon(element,1)"
                >{{element.videoCount||0}}</div>
              </el-tooltip> -->
              <div style="width: 20%" class="delete">
                <!-- <i
                    slot="reference"
                    class="el-icon-delete mainColor"
                    title="解绑"
                    @click="deleteGoodsItem(element.id)"
                ></i>-->
                <el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon="el-icon-info" icon-color="red" @confirm="deleteGoodsItem(element.id)" @onCancel="deleteCancel" title="确定解绑吗？">
                  <el-button type="text" slot="reference">解绑</el-button>
                </el-popconfirm>
                <!-- <el-popconfirm
                  confirmButtonText="确定"
                  cancelButtonText="取消"
                  icon="el-icon-info"
                  iconColor="red"
                  @confirm="deleteGoodsItem(element.id)"
                  @cancel="deleteCancel"
                  title="确定解绑吗？"
                >
                  <span slot="reference" class="mainColor">解绑</span>
                </el-popconfirm> -->
                <span v-if="element.type == '录播'" style="margin-left: 30px" class="mainColor" @click="opConmon(element, 1)">查看</span>
              </div>
            </div>
          </div>
          <!-- </transition-group> -->
        </draggable>
        <div v-else style="
            text-align: center;
            line-height: 60px;
            color: #909399;
            border-bottom: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
          ">
          暂无数据
        </div>
      </div>
      <el-pagination background @size-change="sizeChange" @current-change="currentChange" :page-sizes="[10, 50, 100, 200]" :current-page="page.pageNumber" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total" style="margin-top: 20px; text-align: right"></el-pagination>
    </el-card>

    <el-dialog title="添加排班" :visible.sync="addVideoVisible" width="800px" left>
      <el-form ref="searchForm" :model="videoSearchForm" :label-width="formLabelWidths">
        <el-row :gutter="20">
          <el-col :sm="8" :md="8" :lg="8">
            <el-cascader style="width:100%;" v-model="searchForm.campusId" :show-all-levels="false" :props="campusTreeProps" placeholder="请选择所属校区" :options="campusList" clearable @change="campusIdChange(searchForm.campusId)"></el-cascader>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-cascader style="width:100%" clearable v-model="searchForm.courseIds" :show-all-levels="false" :props="subjectTreeProp" placeholder="请选择所属科目" :options="ClassInfoTree" @change="subjectIdChange()"></el-cascader>
          </el-col>
          <el-col :sm="8" :md="8" :lg="8">
            <el-button style="margin-left: 20px" type="primary" @click="videocoursePageList" icon="el-icon-search">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="videocoursePage.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%" border @selection-change="selectionChange" v-loading='loadingV'>
        <el-table-column show-overflow-tooltip type="selection" width="55"></el-table-column>
        <el-table-column show-overflow-tooltip prop="campusName" label="校区"></el-table-column>
        <el-table-column show-overflow-tooltip prop="subjectName" label="科目"></el-table-column>
        <el-table-column show-overflow-tooltip prop="type" label="班级类型"></el-table-column>
        <el-table-column prop="createTime" show-overflow-tooltip label="开班时间" align="center" width="180">
          <template slot-scope="scope">{{scope.row.startDate}}-{{scope.row.endDate}}</template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 50, 100, 200]" style="margin-top: 20px; text-align: right" :total="videocoursePage.total" :page-size="videocoursePage.pageSize" :current-page="videocoursePage.pageNumber" @size-change="videoSizeChange" @current-change="videoCurrentChange"></el-pagination>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="addVideoVisible = false">取 消</el-button>
        <el-button @click="addGoodsItemBatch" type="primary">添 加</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import draggable from "vuedraggable";
import conmon from "../videoCourse/conmon";

export default {
  components: { conmon },
  data () {
    return {
      queryData: {},
      powerList: [],
      checkList: [],
      isPrpover: false,
      videoDialog: false,
      bindVisible: false,
      comMonid: "",
      typeName: "",
      subjectTreeProp: {
        value: "id",
        label: "name",
        children: "children"
      },
      campusTreeProps: {
        value: "id",
        label: "name",
        children: "children"
        // checkStrictly: true
      },
      loadingV: false,
      campusList: [],
      ClassInfoTree: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "", //url地址
          },
        ],
        poster: "../../static/images/test.jpg", //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      },
      pList: [], //二级列表
      ppList: [], //一级列表
      videoCourseIds: [],
      subjectTreeList: [], //科目
      page1: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      videocoursePage: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      livePage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      subjectPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      chapterPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        level: 2,
        sortName: "",
        sortOrder: "",
      },
      actualOperationPage: {
        rows: [],
        total: 0,
        pageSize: 100,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      actualOperationForm: {},
      addVideoVisible: false,
      addLiveVisible: false,
      addSubjectVisible: false,
      addChapterVisible: false,
      addActualOperationVisible: false,
      searchForm: {},
      videoSearchForm: {},
      liveSearchForm: {},
      subjectForm: {},
      chapterForm: {
        ppid: "",
        pid: "",
      },
      formLabelWidth: "80px",
      formLabelWidths: "100px",
      selection: "",
      multipleSelection: "",
      ids: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick (picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      fileAction: `${process.env.BASE_URL}/goodsItem/upload`,
      fileList: [],
      loading: true,
      goodsItemIdData: [],
      type: "",
      chapterListType: "",
    };
  },
  components: {
    draggable,
  },
  methods: {
    // 范围弹出窗赋初值
    rangeCli (form) {
      this.checkList = [];
      this.powerList = JSON.parse(JSON.stringify(form.powerList));
      form.powerList.forEach((item) => {
        if (item.hasPower) this.checkList.push(item.power);
      });
    },
    // 范围更改提交
    sunmitType (element) {
      let val = 0;
      this.checkList.forEach((item) => (val = val | +item));
      let obj = JSON.parse(JSON.stringify(element));
      obj.power = val;
      // console.log(obj);
      this.api.videoInfo.updateGoodsItem(obj).then((res) => {
        if (res.code == 200) {
          element.isPrpover = false;
          this.$message.success(res.message);
        } else this.$message.error(res.message);
        this.pageList();
      });
    },
    opConmon (row, sty) {
      this.bindVisible = true;
      this.comMonid = sty == 1 ? row.objectId : row.id;
      this.typeName = row.type;
      this.pageList1();
    },
    pageList1 () {
      this.page1.videoCourseId = this.comMonid;
      this.api.videoInfo
        .pageList(this.page1)
        .then((result) => {
          if (result.success) {
            this.page1.rows = result.data.records;
            this.page1.total = result.data.total;
          } else {
            this.$message.error(result.message);
          }
        })

        .catch((error) => {
          console.log(error);
        });
    },
    closeDialog () {
      this.$refs.videoPlayer.player.pause(); //暂停
    },
    deleteCancel () {
      // alert(0);
    },
    datadragEnd (evt) {
      console.log(evt);
      let arr = [];
      this.page.rows.forEach((item, index) => {
        arr.push({
          id: item.id,
          sort: index + 1,
        });
      });
      console.log(arr);
      this.api
        .changeSort(arr)
        .then((result) => {
          this.$message.success(result.message);
        })
        .catch((error) => {
          console.log(error);
        });
      evt.preventDefault();
      // console.log("拖动前的索引 :" + evt.oldIndex);
      // console.log("拖动后的索引 :" + evt.newIndex);
      // console.log(this.colors);
    },
    addGoodsVideo () {
      this.type = "录播课程";
      this.getSubjectTreeList();
      this.videocoursePageList();
      this.addVideoVisible = true;
    },
    addLiveVideo () {
      this.type = "直播课程";
      this.getSubjectTreeList();
      this.livePageList();
      this.addLiveVisible = true;
    },
    addGoodsSubject () {
      this.type = "试卷";
      this.getSubjectTreeList();
      this.pageListExamType();
      this.addSubjectVisible = true;
    },
    addGoodsChapter (chapterListType) {
      // this.type = "章节";
      this.chapterListType = chapterListType;
      this.type = chapterListType + "课程";
      this.getTypeLit();
      this.pageListChapter();
      this.addChapterVisible = true;
    },
    addGoodsActualOperation () {
      this.type = "实训课程";
      this.pageListActualOperation();
      this.addActualOperationVisible = true;
    },
    videoSubjectChange (val) {
      this.videoSearchForm.courseIds = [];
      val.forEach((item) => {
        this.videoSearchForm.courseIds.push(item[2]);
      });
    },
    subjectChange (val) {
      this.subjectForm.ids = [];
      val.forEach((item) => {
        this.subjectForm.ids.push(item[2]);
      });
    },
    videocoursePageList () {
      this.videoSearchForm.pageSize = this.videocoursePage.pageSize;
      this.loadingV = true
      this.videoSearchForm.pageNumber = this.videocoursePage.pageNumber;
      this.api.classInfoPhase.pageList(this.videoSearchForm).then((result) => {
        this.loadingV = false
        this.videocoursePage.rows = result.data.records;
        this.videocoursePage.total = result.data.total;
      }).catch((error) => {
        this.loadingV = false
        console.log(error);
      });
    },
    livePageList () {
      this.liveSearchForm.subjectId = this.$route.query.subjectId;
      this.liveSearchForm.pageSize = this.livePage.pageSize;
      this.liveSearchForm.pageNumber = this.livePage.pageNumber;
      this.liveSearchForm.sortName = this.livePage.sortName;
      this.liveSearchForm.sortOrder = this.livePage.sortOrder;
      this.liveSearchForm.type = "1";
      this.api.liveRoom.pageList(this.liveSearchForm).then((result) => {
        this.livePage.rows = result.data.records;
        this.livePage.total = result.data.total;
      }).catch((error) => {
        console.log(error);
      });
    },
    pageListExamType () {
      this.subjectForm.pageSize = this.subjectPage.pageSize;
      this.subjectForm.pageNumber = this.subjectPage.pageNumber;
      this.subjectForm.sortName = this.subjectPage.sortName;
      this.subjectForm.sortOrder = this.subjectPage.sortOrder;
      this.api.goodsItem
        .pageListExamType(this.subjectForm)
        .then((result) => {
          this.subjectPage.rows = result.data.records;
          this.subjectPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListChapter () {
      this.chapterForm.pageSize = this.chapterPage.pageSize;
      this.chapterForm.pageNumber = this.chapterPage.pageNumber;
      this.chapterForm.level = this.chapterPage.level;
      this.chapterForm.sortName = this.chapterPage.sortName;
      this.chapterForm.sortOrder = this.chapterPage.sortOrder;
      this.chapterForm.pid = this.$route.query.subjectId;

      this.api.subjectCourse
        .getPageList(this.chapterForm)
        .then((result) => {
          this.chapterPage.rows = result.data.records;
          this.chapterPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    pageListActualOperation () {
      this.actualOperationForm.pageSize = this.actualOperationPage.pageSize;
      this.actualOperationForm.pageNumber = this.actualOperationPage.pageNumber;
      this.actualOperationForm.sortName = this.actualOperationPage.sortName;
      this.actualOperationForm.sortOrder = this.actualOperationPage.sortOrder;
      this.api.goodsItem
        .actualOperationPageList(this.actualOperationForm)
        .then((result) => {
          this.actualOperationPage.rows = result.data.records;
          this.actualOperationPage.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addGoodsItemBatch () {
      let arr = []
      this.ids.forEach(v => {
        arr.push(v.objectId)
      })
      this.api.goodsItem.addGoodsClassRelation({
        goodsId: this.$route.query.updatePageGoodsItem,
        classInfoIds: arr
      }).then((result) => {
        if (result.success) {
          this.addVideoVisible = false;
          this.addSubjectVisible = false;
          this.addChapterVisible = false;
          this.addLiveVisible = false;
          this.addActualOperationVisible = false;
          this.pageList();
          this.$message.success(result.message);
          this.ids = [];
        } else {
          this.$message(result.message);
        }
      });
    },
    deleteGoodsItem (vId) {
      let params = {
        goodsId: this.$route.query.updatePageGoodsItem,
        classInfoIds: [vId]
      }
      this.api.goodsItem.unbindGoodsArrange(params).then((result) => {
        this.pageList();
        this.$message.success("解绑成功");
      });
    },
    getSubjectTreeList () {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取一级列表
    getTypeLit () {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: 0,
        })
        .then((result) => {
          this.ppList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //获取二级列表
    choosePPid () {
      this.api.subjectCourse
        .getSubjectCourseListByPid({
          pid: this.chapterForm.ppid,
        })
        .then((result) => {
          this.pList = result.data;
          this.chapterForm.pid = "";
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getGoodsItemData () {
      this.api.goodsInfo
        .getGoodsInfo({ id: this.$route.query.updatePageGoodsItem })
        .then((result) => {
          this.goodsItemIdData = result.data;
          console.log("this..goodsItemdata", this.goodsItemIdData);
          this.pageList();
        });
      console.log(this.goodsItemIdData);
    },
    sizeChange (pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange (pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    sizeChange1 (pageSize) {
      this.page1.pageSize = pageSize;
      this.pageList1();
    },
    currentChange1 (pageNumber) {
      this.page1.pageNumber = pageNumber;
      this.pageList1();
    },

    videoSizeChange (pageSize) {
      this.videocoursePage.pageSize = pageSize;
      this.videocoursePageList();
    },
    videoCurrentChange (pageNumber) {
      this.videocoursePage.pageNumber = pageNumber;
      this.videocoursePageList();
    },
    liveSizeChange (pageSize) {
      this.livePage.pageSize = pageSize;
      this.livePageList();
    },
    liveCurrentChange (pageNumber) {
      this.livePage.pageNumber = pageNumber;
      this.livePageList();
    },
    subjectSizeChange (pageSize) {
      this.subjectPage.pageSize = pageSize;
      this.pageListExamType();
    },
    subjectCurrentChange (pageNumber) {
      this.subjectPage.pageNumber = pageNumber;
      this.pageListExamType();
    },
    chapterSizeChange (pageSize) {
      this.chapterPage.pageSize = pageSize;
      this.pageListChapter();
    },
    chapterCurrentChange (pageNumber) {
      this.chapterPage.pageNumber = pageNumber;
      this.pageListChapter();
    },
    actualOperationSizeChange (pageSize) {
      this.actualOperationPage.pageSize = pageSize;
      this.pageListActualOperation();
    },
    actualOperationCurrentChange (pageNumber) {
      this.actualOperationPage.pageNumber = pageNumber;
      this.pageListActualOperation();
    },

    selectionChange (val) {
      this.multipleSelection = val;
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
      console.log(this.ids)
    },
    liveSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    subjectSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
        examType: e.examType,
      }));
    },
    chapterSelectionChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    actualOperationChange (val) {
      this.ids = val.map((e) => ({
        objectId: e.id,
        goodsId: this.goodsItemIdData.id,
        type: this.type,
      }));
    },
    pageList () {
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.pageNumber = this.page.pageNumber;
      this.searchForm.sortName = this.page.sortName;
      this.searchForm.sortOrder = this.page.sortOrder;
      this.searchForm.goodsId = this.$route.query.updatePageGoodsItem,
        this.api.goodsItem.arrangePageList(this.searchForm).then((result) => {
          this.page.rows = result.data ? result.data.records : [];
          this.page.total = result.data.total;
          this.loading = false;
        }).catch((error) => {
          console.log(error);
        });
    },
    //获取课程树
    getTree () {
      this.api.subjectCourse.getSubjectTreeList().then(result => {
        if (result.success) {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                delete items.children;
                // if (items.children.length != 0) {
                //   for (let itemss of items.children) {
                //     delete itemss.children;
                //   }
                // } else {
                //   // delete items.children;
                // }
              }
            } else {
              // delete item.children;
            }
          }
          this.ClassInfoTree = result.data;
          if (this.ClassInfoTree.length > 0) {
          } else {
            this.classManageList = [];
            this.$message.waring("该校区暂无科目课程");
          }
        }
      }).catch(error => {
        console.log(error);
      });
    },
    getCampusTree () {
      this.api.campus.getCampusTree({ parentId: 1 }).then(result => {
        if (result.success) {
          if (result.data.length == 0) {
            this.$message.error("暂无校区，请创建校区");
            this.loading = false;
            return;
          }
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    if (itemss.children.length != 0) {
                      delete itemss.children;
                    } else {
                      delete itemss.children;
                    }
                  }
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          if (result.data.length > 0) {
            this.campusList = result.data;
          }
        } else {
          this.$message.error(result.message);
          this.loading = false;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    campusIdChange (item) {
      if (item) {
        let index = length;
        this.videoSearchForm.campusId = this.videoSearchForm.campusId[index - 1];
      } else {
        this.videoSearchForm.campusId = null;
      }
    },
    subjectIdChange () {
      if (this.searchForm.courseIds) {
        this.videoSearchForm.subjectCourseId = this.searchForm.courseIds[1];
      } else {
        this.videoSearchForm.subjectCourseId = null;
      }
    },
  },
  mounted () {
    this.getTree()
    this.getCampusTree()
    this.getGoodsItemData();
    this.queryData = this.$route.query;
  },
};
</script>
<style lang="less" scoped>
.type-btn {
  transform: translateX(-50%);
  margin-left: 50%;
  margin-top: 15px;
}
.line {
  display: inline-block;
  margin: 0 5px;
  border-left: 1px solid #a39e9e75;
  height: 10px;
}
.draggable-tableaaa {
  margin-top: 20px;
  border-top: 1px solid #d9ebf5;
  border-left: 1px solid #d9ebf5;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .bor {
    font-weight: bolder;
    color: #4e4e4e;
    background-color: rgb(250, 250, 250) !important;
  }
  .draggable-table {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    div {
      padding: 8px 10px;
      font-size: 12px;
      line-height: 23px;
    }
    .htmltittles {
      white-space: nowrap;
      padding: 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      img {
        display: none !important;
      }
      p {
        font-size: 12px !important;
        line-height: 23px !important;
        margin: 0px !important;
        color: #606266 !important;
        white-space: nowrap !important;
        img {
          display: none !important;
        }
      }
    }
    .title {
      width: 60%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .state {
        padding: 0;
        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      .questionTypeName {
        padding: 0;

        span {
          padding: 4px 8px;
          color: #fff;
          border-radius: 4px;
          margin-right: 10px;
        }
      }
      white-space: nowrap;
    }
    .answer {
      width: 22%;
      border-bottom: 1px solid #d9ebf5;
      border-right: 1px solid #d9ebf5;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .delete {
      width: 12%;
      cursor: pointer;
      border-bottom: 1px solid #d9ebf5;
      text-align: center;
      border-right: 1px solid #d9ebf5;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goods/goodsSchedule.vue